import React, {useState} from "react";
import {useSelector} from "react-redux";

import Seat from "../../components/Seat";

export default function CD268(props) {
    const { id, reservedSeats, preliminaryReservedSeats, announcedNumber, number } = props;

    const activeSeats = useSelector(state => state.activeSeats);

    const isAvailable = (carriageId, seatNumber) => {
        const isReserved = reservedSeats.some(seat => {
            return (seat.carriageId === carriageId && String(seat.number) === String(seatNumber))
        });
        const isPreliminaryReserved = preliminaryReservedSeats && preliminaryReservedSeats.some(seat => {
            return (seat.carriageId === carriageId && String(seat.number) === String(seatNumber))
        });
        return !isReserved && !isPreliminaryReserved;
    };

    const isActive = (carriage, number) => {
        return Object.keys(activeSeats).some(seat => (seat.carriage === carriage && seat.seat === number))
    };

    return (
        <div className="wagon-box compartment-coach">
            <div className="compartment-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="1" available={isAvailable(id, 1)} active={isActive(id, 1)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="2" available={isAvailable(id, 2)} active={isActive(id, 2)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="3" available={isAvailable(id, 3)} active={isActive(id, 3)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="4" available={isAvailable(id, 4)} active={isActive(id, 4)} />
            </div>
            <div className="door" />
            <div className="compartment-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="5" reverse={true} available={isAvailable(id, 5)} active={isActive(id, 5)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="6" reverse={true} available={isAvailable(id, 6)} active={isActive(id, 6)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="7" reverse={true} available={isAvailable(id, 7)} active={isActive(id, 7)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="8" reverse={true} available={isAvailable(id, 8)} active={isActive(id, 8)} />
            </div>
            <div className="wall-compartment-top">
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
            </div>
            <div className="compartment-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="17" available={isAvailable(id, 17)} active={isActive(id, 17)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="18" available={isAvailable(id, 18)} active={isActive(id, 18)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="19" available={isAvailable(id, 19)} active={isActive(id, 19)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="20" available={isAvailable(id, 20)} active={isActive(id, 20)} />
            </div>
            <div className="door" />
            <div className="compartment-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="21" reverse={true} available={isAvailable(id, 21)} active={isActive(id, 21)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="22" reverse={true} available={isAvailable(id, 22)} active={isActive(id, 22)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="23" reverse={true} available={isAvailable(id, 23)} active={isActive(id, 23)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="24" reverse={true} available={isAvailable(id, 24)} active={isActive(id, 24)} />
            </div>
            <div className="wall-compartment-top">
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
            </div>
            <div className="compartment-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="9" available={isAvailable(id, 9)} active={isActive(id, 9)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="10" available={isAvailable(id, 10)} active={isActive(id, 10)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="11" available={isAvailable(id, 11)} active={isActive(id, 11)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="12" available={isAvailable(id, 12)} active={isActive(id, 12)} />
            </div>
            <div className="door" />
            <div className="compartment-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="13" reverse={true} available={isAvailable(id, 13)} active={isActive(id, 13)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="14" reverse={true} available={isAvailable(id, 14)} active={isActive(id, 14)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="15" reverse={true} available={isAvailable(id, 15)} active={isActive(id, 15)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="16" reverse={true} available={isAvailable(id, 16)} active={isActive(id, 16)} />
            </div>
        </div>
    )
}
